export const setLocalStorage = (key, value) =>
  localStorage.setItem("skv_" + key, value);

export const getLocalStorage = (key) =>
  localStorage.getItem("skv_" + key);

export const removeLocalStorage = (key) =>
  localStorage.removeItem("skv_" + key);
